<!-- Seitenkopf steht auf dem Hintergrund, nicht in der Karte — dieselbe
     Konvention wie Moodle-Übersicht, faqs und Platzierungen. -->
<div class="header">
  <div>
    <h2>{{ 'pages.ilias.title' | translate }}</h2>
    <p class="subtitle">{{ 'pages.ilias.hint' | translate }}</p>
  </div>
  <div class="ilias-dashboard__header-actions">
    <nb-select
      *ngIf="connections.length > 1"
      size="small"
      [selected]="selectedConnectionId"
      (selectedChange)="onConnectionChange($event)"
    >
      <nb-option *ngFor="let c of connections" [value]="c.id">
        {{ c.display_name || c.issuer }}
        <span *ngIf="c.environment === 'staging'"> · {{ 'pages.ilias.staging' | translate }}</span>
      </nb-option>
    </nb-select>
    <button
      nbButton
      status="primary"
      outline
      class="secondary-action-button"
      (click)="runSync()"
      [disabled]="!soapConfigured || syncing || loading"
      [nbTooltip]="'pages.ilias.sync.runTooltip' | translate"
    >
      <nb-icon [icon]="syncing ? 'sync-outline' : 'refresh-outline'" [class.spin]="syncing"></nb-icon>
      {{ (syncing ? 'pages.ilias.sync.running' : 'pages.ilias.sync.run') | translate }}
    </button>
  </div>
</div>

<!-- Keine Verbindung: die Seite hat nichts zu zeigen und sagt, wo es weitergeht. -->
<nb-card *ngIf="connections.length === 0" class="ilias-dashboard">
  <nb-card-body class="ilias-dashboard__empty">
    <nb-icon icon="link-2-outline"></nb-icon>
    <p>{{ 'pages.ilias.noConnection' | translate }}</p>
  </nb-card-body>
</nb-card>

<ng-container *ngIf="connections.length > 0">
  <nb-card class="ilias-dashboard">
    <nb-card-body>
      <nb-tabset (changeTab)="onTabChange($event.tabId)">
        <!-- ─── Kurse ──────────────────────────────────────────── -->
        <nb-tab tabId="courses" [tabTitle]="'pages.ilias.tabs.courses' | translate">
          <div class="ilias-dashboard__filters">
            <nb-form-field class="ilias-dashboard__filter">
              <nb-icon nbPrefix icon="search-outline"></nb-icon>
              <input
                type="text"
                nbInput
                fieldSize="small"
                [placeholder]="'pages.ilias.searchCourse' | translate"
                [value]="search.courses"
                (input)="onSearchChange($any($event.target).value)"
              />
              <nb-icon
                *ngIf="search.courses"
                nbSuffix
                icon="close-outline"
                class="ilias-dashboard__clear-search"
                (click)="onSearchChange('')"
                [attr.title]="'pages.ilias.clearSearch' | translate"
              ></nb-icon>
            </nb-form-field>
          </div>

          <div class="table-wrap">
            <!-- Dieselbe Tabellenkomponente wie im Moodle-Dashboard und in
                 der Wissensbasis. Die handgebaute Tabelle davor hatte kein
                 Zeilenmenue und keine Mehrfachauswahl — beides steckt hier
                 schon drin, und genau deshalb fehlten der ILIAS-Uebersicht
                 Funktionen, die es fuer Moodle laengst gab.

                 Die Seitenzahlen bleiben die eigenen: sie blaettern
                 serverseitig (limit/offset), der eingebaute Pager liefe nur
                 ueber die schon geladene Seite. -->
            <app-table
              *ngIf="!loading && courses.length > 0"
              rowIdKey="ref_id"
              [title]="'pages.ilias.tabs.courses' | translate"
              [columns]="courseColumns"
              [data]="courses"
              [rowActions]="courseRowActions"
              [selectable]="true"
              [showPagination]="false"
              (event)="onCourseTableEvent($event)"
            ></app-table>
            <p class="empty" *ngIf="!loading && courses.length === 0">
              {{ 'pages.ilias.emptyCourses' | translate }}
            </p>
          </div>
        </nb-tab>

        <!-- ─── Lernende ───────────────────────────────────────── -->
        <nb-tab tabId="users" [tabTitle]="'pages.ilias.tabs.users' | translate">
          <div class="ilias-dashboard__filters">
            <nb-form-field class="ilias-dashboard__filter">
              <nb-icon nbPrefix icon="search-outline"></nb-icon>
              <input
                type="text"
                nbInput
                fieldSize="small"
                [placeholder]="'pages.ilias.searchUser' | translate"
                [value]="search.users"
                (input)="onSearchChange($any($event.target).value)"
              />
              <nb-icon
                *ngIf="search.users"
                nbSuffix
                icon="close-outline"
                class="ilias-dashboard__clear-search"
                (click)="onSearchChange('')"
                [attr.title]="'pages.ilias.clearSearch' | translate"
              ></nb-icon>
            </nb-form-field>
          </div>

          <div class="table-wrap">
            <table class="ilias-table">
              <thead>
                <tr>
                  <th>{{ 'pages.ilias.col.name' | translate }}</th>
                  <th>{{ 'pages.ilias.col.login' | translate }}</th>
                  <th>{{ 'pages.ilias.col.email' | translate }}</th>
                  <th class="num">{{ 'pages.ilias.col.enrollments' | translate }}</th>
                  <th class="num">{{ 'pages.ilias.col.completed' | translate }}</th>
                  <th class="num">{{ 'pages.ilias.col.tests' | translate }}</th>
                  <th class="num">{{ 'pages.ilias.col.passed' | translate }}</th>
                  <th class="num">{{ 'pages.ilias.col.avgScore' | translate }}</th>
                  <th>{{ 'pages.ilias.col.lastProgress' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of users" [class.inactive]="!row.active">
                  <td class="strong">{{ personName(row) }}</td>
                  <td class="muted">{{ row.login || '—' }}</td>
                  <td class="muted">{{ row.email || '—' }}</td>
                  <td class="num">{{ row.enrollment_count }}</td>
                  <td class="num">{{ row.completed_count }}</td>
                  <td class="num">{{ row.test_count || '—' }}</td>
                  <td class="num">{{ row.test_count ? row.test_passed : '—' }}</td>
                  <td class="num">
                    {{ row.avg_percentage !== null ? row.avg_percentage + '%' : '—' }}
                  </td>
                  <td class="muted">
                    {{ row.last_progress_at ? (row.last_progress_at | date: 'short') : '—' }}
                  </td>
                </tr>
                <tr *ngIf="!loading && users.length === 0">
                  <td colspan="9" class="empty">{{ 'pages.ilias.emptyUsers' | translate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </nb-tab>

        <!-- ─── Dozenten ───────────────────────────────────────── -->
        <nb-tab tabId="teachers" [tabTitle]="'pages.ilias.tabs.teachers' | translate">
          <div class="ilias-dashboard__filters">
            <nb-form-field class="ilias-dashboard__filter">
              <nb-icon nbPrefix icon="search-outline"></nb-icon>
              <input
                type="text"
                nbInput
                fieldSize="small"
                [placeholder]="'pages.ilias.searchTeacher' | translate"
                [value]="search.teachers"
                (input)="onSearchChange($any($event.target).value)"
              />
              <nb-icon
                *ngIf="search.teachers"
                nbSuffix
                icon="close-outline"
                class="ilias-dashboard__clear-search"
                (click)="onSearchChange('')"
                [attr.title]="'pages.ilias.clearSearch' | translate"
              ></nb-icon>
            </nb-form-field>
          </div>

          <div class="table-wrap">
            <table class="ilias-table">
              <thead>
                <tr>
                  <th>{{ 'pages.ilias.col.name' | translate }}</th>
                  <th>{{ 'pages.ilias.col.email' | translate }}</th>
                  <th class="num">{{ 'pages.ilias.col.courseCount' | translate }}</th>
                  <th>{{ 'pages.ilias.col.courses' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of teachers">
                  <td class="strong">{{ personName(row) }}</td>
                  <td class="muted">{{ row.email || '—' }}</td>
                  <td class="num">{{ row.course_count }}</td>
                  <td>
                    <span *ngFor="let c of row.courses" class="course-chip">
                      {{ c.title || ('#' + c.ref_id) }}
                      <small>{{ roleLabel(c.role) }}</small>
                    </span>
                  </td>
                </tr>
                <tr *ngIf="!loading && teachers.length === 0">
                  <td colspan="4" class="empty">{{ 'pages.ilias.emptyTeachers' | translate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </nb-tab>
      </nb-tabset>

      <div class="ilias-dashboard__pager" *ngIf="pageCount > 1">
        <button
          nbButton
          ghost
          size="small"
          [disabled]="currentPage === 0 || loading"
          (click)="goToPage(currentPage - 1)"
        >
          <nb-icon icon="arrow-ios-back-outline"></nb-icon>
        </button>
        <span>
          {{ 'pages.ilias.pageOf' | translate: { page: currentPage + 1, total: pageCount } }}
          · {{ currentTotal }}
        </span>
        <button
          nbButton
          ghost
          size="small"
          [disabled]="currentPage >= pageCount - 1 || loading"
          (click)="goToPage(currentPage + 1)"
        >
          <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
        </button>
      </div>
    </nb-card-body>
  </nb-card>
</ng-container>
